// Reveal on scroll
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
}, { threshold: 0.14 });
document.querySelectorAll('.rv').forEach(el => io.observe(el));

// Sombra del header al hacer scroll
const hdr = document.querySelector('header');
addEventListener('scroll', () => hdr.classList.toggle('scrolled', scrollY > 10), { passive: true });

// Contadores animados (respeta reduced motion)
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const counterIO = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, target = +el.dataset.count;
    counterIO.unobserve(el);
    if (reduce || el.dataset.plain) { el.textContent = target; return; }
    const t0 = performance.now(), dur = 1500;
    const tick = now => {
      const p = Math.min((now - t0) / dur, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
}, { threshold: 0.6 });
document.querySelectorAll('[data-count]').forEach(el => counterIO.observe(el));
